export default __webpack_public_path__ + "media/images/us_flag.png";